(function () {
  function knpInit(root) {
    if (!root || root.dataset.knpReady) return;
    root.dataset.knpReady = '1';
    var form = root.querySelector('.knp__form');
    var prices = root.querySelectorAll('[data-knp-price]');
    var compares = root.querySelectorAll('[data-knp-compare]');
    var pct = root.querySelector('[data-knp-pct]');
    root.querySelectorAll('input[name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        prices.forEach(function (p) { p.textContent = r.dataset.price; });
        compares.forEach(function (c) {
          if (r.dataset.compare) { c.innerHTML = r.dataset.compare; c.hidden = false; }
          else { c.hidden = true; }
        });
        if (pct) {
          if (r.dataset.pct) { pct.innerHTML = r.dataset.pct; pct.hidden = false; }
          else { pct.hidden = true; }
        }
      });
    });
    var main = root.querySelector('.knp__main-img');
    root.querySelectorAll('.knp__thumb').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = b.dataset.src;
        root.querySelectorAll('.knp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
    var colorName = root.querySelector('[data-knp-color-name]');
    root.querySelectorAll('.knp__swatch input').forEach(function (c) {
      c.addEventListener('change', function () {
        if (colorName) colorName.textContent = c.value;
        if (main && c.dataset.img) {
          main.removeAttribute('srcset');
          main.src = c.dataset.img;
          root.querySelectorAll('.knp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        }
      });
    });

    // Zoom: Tippen/Klicken auf das Hauptbild zeigt es groß (nicht nach einem Wischen)
    var stage = root.querySelector('.knp__main');
    var zoom = root.querySelector('.knp__zoom');
    if (stage && main && zoom) {
      var zoomImg = zoom.querySelector('.knp__zoom-img');
      var closeBtn = zoom.querySelector('.knp__zoom-close');
      var lastFocus = null;
      var openZoom = function () {
        zoomImg.src = main.hasAttribute('srcset') ? (stage.dataset.zoom || main.currentSrc || main.src) : main.src;
        zoom.hidden = false;
        document.documentElement.classList.add('knp-zoom-open');
        lastFocus = document.activeElement;
        closeBtn.focus();
      };
      var closeZoom = function () {
        zoom.hidden = true;
        document.documentElement.classList.remove('knp-zoom-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };
      stage.addEventListener('click', function () {
        if (Date.now() - Number(stage.dataset.swipedAt || 0) < 500) return;
        openZoom();
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); }
      });
      zoom.addEventListener('click', function (e) {
        if (e.target !== zoomImg) closeZoom();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !zoom.hidden) closeZoom();
      });
    }

    // Sticky-Leiste: sichtbar, solange der Haupt-Button nicht im Bild ist.
    // Vor den Angeboten springt der Button dorthin, danach legt er in den Warenkorb.
    var sticky = root.querySelector('.knp__sticky');
    var atc = root.querySelector('.knp__form .knp__atc');
    var offers = root.querySelector('.knp__bundles');
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (e) {
        sticky.classList.toggle('is-visible', !e[0].isIntersecting);
      }).observe(atc);
      sticky.querySelector('button').addEventListener('click', function () {
        var target = offers || atc;
        if (target.getBoundingClientRect().top > window.innerHeight * 0.5) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    }
  }
  function knpAll() { document.querySelectorAll('[data-knp]').forEach(knpInit); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', knpAll); } else { knpAll(); }
  document.addEventListener('shopify:section:load', knpAll);
})();